import { Logger, LogLevel } from "msal";
import { LoginType, MsalAuthProvider } from "react-aad-msal";
import "regenerator-runtime/runtime";
const {
    ACTIVE_DIRECTORY_APP_CLIENT_ID,
    ACTIVE_DIRECTORY_APP_AUTHORITY,
    ACTIVE_DIRECTORY_TENANT_ID,
    NODE_ENV
  } = process.env;
const isDevelopment = NODE_ENV === "development";

const logger = new Logger(
  (logLevel, message, containsPii) => {
    if(isDevelopment){
     // console.log("[MSAL]", message);
    }
  },
  {
    level: isDevelopment ? LogLevel.Verbose : LogLevel.Error,
    piiLoggingEnabled: false
  }
);

export const authProvider = new MsalAuthProvider(
  {
    auth: {
      authority: `${ACTIVE_DIRECTORY_APP_AUTHORITY}/${ACTIVE_DIRECTORY_TENANT_ID}`,
      clientId: `${ACTIVE_DIRECTORY_APP_CLIENT_ID}`,
      // postLogoutRedirectUri: window.location.href,
      // redirectUri: window.location.href,
      postLogoutRedirectUri: window.location.origin,
      redirectUri: window.location.origin,
      validateAuthority: true,

      // After being redirected to the "redirectUri" page, should user
      // be redirected back to the Url where their login originated from?
      navigateToLoginRequestUrl: true
    },
    // Enable logging of MSAL events for easier troubleshooting.
    // This should be disabled in production builds.
    system: {
      logger: logger as any
    },
    cache: {
      cacheLocation: "sessionStorage",
      storeAuthStateInCookie: false
    }
  },
  {
    scopes: ["openid", "profile", "User.Read"]
  },
  {
    loginType: LoginType.Redirect,
    // When a token is refreshed it will be done by loading a page in an iframe.
    // Rather than reloading the same page, we can point to an empty html file which will prevent
    // site resources from being loaded twice.
    tokenRefreshUri: window.location.origin + "/auth.html"
  }
);
